<script setup lang="ts">
import {appAuthor, appAuthorWebsite, appTitle, currentYear} from "@/helpers";
import {Heart} from "lucide-vue-next";

const version = __APP_VERSION__;
const gitHash = __GIT_HASH__;
</script>

<template>
<span>
  <p class="text-base text-sm text-default-400">
    {{ currentYear }}
    © {{ appTitle }} | v{{version}} | #{{gitHash}} | <a target="_blank" :href="appAuthorWebsite">
    developed, loaded and run with <Heart class="inline h-4 w-4 text-red-500 fill-red-500"/>
    by {{ appAuthor }}</a>
  </p>

</span>
</template>

<style scoped>

</style>
